export default __webpack_public_path__ + "static/media/pic26.bd5253c4.jpg";